import { useDisableTeam } from "@/components/page/disableTeam";
import { useProtected } from "@/hooks/useProtected";
import { Outlet } from "react-router-dom";

export const AppRoot = () => {
  useProtected();

  useDisableTeam(false);

  return <Outlet />;
};

export { DashboardPage } from "./Dashboard";
export { ProfilePage } from "./Profile";
